import { css } from 'linaria';
import React from 'react';
import { DropdownMenu } from '@jetshop/ui/DropdownMenu';
import { dropdownStyles } from '../../ui/Dropdown';

const menu = css`
  ${dropdownStyles};
`;

export function FilterDropdownMenu(props) {
  return <DropdownMenu className={menu} {...props} />;
}
